'use client';

import React from 'react';
import { CanLogoIcon } from '@/../public/assets/icons';
import { Box, Text } from '@chakra-ui/react';
import 'react-phone-input-2/lib/style.css';
import ClinicDetailsForm from '../../forms/clinic/clinic-details/ClinicDetailsForm';
import { TClinicDetailsProps } from './types/template.types';

const ClinicDetails = ({ next, details, previous }: TClinicDetailsProps) => {
   return (
      <>
         <Box minH="72px">
            <CanLogoIcon />
         </Box>
         <Text
            as="h2"
            color="white"
            fontSize={{ base: '4xl', sm: '5xl', md: '12xl' }}
            fontWeight="bold"
            textAlign="center"
         >
            CLINIC DETAILS
         </Text>
         <Text color="white" textStyle="md" textAlign="center" mt="-10px" mb="2">
            Please enter all required information below.
         </Text>
         <ClinicDetailsForm next={next} details={details} previous={previous} />
      </>
   );
};

export default ClinicDetails;
